import React from 'react';
import { Flex, Heading, Text } from '@chakra-ui/react';
import Card from '#coreComponents/Card';
import { SkipSdg } from './SkipSdg';
import { FormData } from './SdgQuiz';
import { SdgImageContainer } from './SdgImageContainer';
import contentJson from '../utils/content.json';
import { useResponsive } from '#core/SdgQuiz/utils';

const content: any = contentJson;

type SdgHeaderCardProps = {
  data: any;
  sdgNumber: number;

  updateFields: (fields: Partial<FormData>) => void;
  handleNext: () => void;
};

const SdgHeaderCard = ({
  data,
  sdgNumber,
  updateFields,
  handleNext,
}: SdgHeaderCardProps) => {
  const currentContent = content[`sdg${sdgNumber}`];

  const isMobileScreen = useResponsive();

  return (
    <Card
      py={isMobileScreen ? 3 : 5}
      px={isMobileScreen ? 3 : 7}
      mb={4}
      maxW="55rem"
    >
      <Flex flexDir="column" m={0}>
        {isMobileScreen ? (
          <Flex mb={1}>
            <SdgImageContainer
              bgPosition={currentContent.imgSpritePositionMobileSmall}
              bgSize={content.imgContainerSizes.imgSizeMobileSmall}
              imgWidth={content.imgContainerSizes.imgSideMobileSmall}
              imgHeight={content.imgContainerSizes.imgSideMobileSmall}
            />

            <Heading
              fontSize="xl"
              as="h1"
              color={currentContent.color}
              ml={2}
              mb={3}
            >
              {currentContent.title}
            </Heading>
          </Flex>
        ) : (
          <Heading as="h1" color={currentContent.color} mb={3}>
            {currentContent.title}
          </Heading>
        )}
        <Text fontSize={isMobileScreen ? 'sm' : 'md'} color="#3A3A3A">
          {currentContent.description}
        </Text>

        <SkipSdg
          data={data}
          sdgNumber={sdgNumber}
          updateFields={updateFields}
          handleNext={handleNext}
        />
      </Flex>
    </Card>
  );
};

export default SdgHeaderCard;
